import api from './index'
import {
	axios,
	pureAxios,
	pyAxios
} from '@/utils/request'
import {
	downLoadXlxs,
	downLoadPdf
} from '@/utils/index'

// 查询接收人列表
export function daily_receiver_daily(parameter) {
	return axios({
		url: 'daily/daily/receiver_daily',
		method: 'GET',
		params: parameter
	})
}

// 查询日报
export function daily_info(parameter) {
	return axios({
		url: '/daily/daily/info',
		method: 'GET',
		params: parameter
	})
}

// 提交
export function daily_info_post(parameter) {
	return axios({
		url: '/daily/daily/info',
		method: 'POST',
		data: parameter
	})
}

// 查询我发出的
export function daily_list(parameter) {
	return axios({
		url: '/daily/daily/list',
		method: 'GET',
		params: parameter
	})
}

// 查询我发出的
export function daily_read(parameter) {
	return axios({
		url: '/daily/daily/read',
		method: 'GET',
		params: parameter
	})
}

// 编辑日报
export function daily_info_put(parameter) {
	return axios({
		url: '/daily/daily/info',
		method: 'PUT',
		data: parameter
	})
}

//查询车辆数据分页
export function listAllPage(data) {
	return axios({
		url: api.gateway_act + 'biz_car_registration/listAllPage',
		method: 'get',
		params: data
	})
}

// 车辆管理新增
export function biz_car_registration(parameter) {
	return axios({
		url:api.gateway_act + 'biz_car_registration/save',
		method: 'POST',
		data: parameter
	})
}

// 车辆管理修改
export function biz_car_registration_update(parameter) {
	return axios({
		url:api.gateway_act + 'biz_car_registration/update',
		method: 'POST',
		data: parameter
	})
}


// 查询可预约车辆
export function biz_car_registration_list(parameter) {
	return axios({
		url: api.gateway_act +'biz_car_registration/list_idle',
		method: 'GET',
		params: parameter
	})
}

// 查询车辆使用详情
export function biz_car_list_detail(parameter) {
	return axios({
		url: api.gateway_act +'biz_car_registration/list_detail',
		method: 'GET',
		params: parameter
	})
}

// 获取手动还车列表
export function biz_car_list_return_car(parameter) {
	return axios({
		url: api.gateway_act +'biz_car_registration/list_return_car',
		method: 'GET',
		params: parameter
	})
}

// 手动还车
export function biz_car_return_car(parameter) {
	return axios({
		url: api.gateway_act +'biz_car_registration/return_car',
		method: 'GET',
		params: parameter
	})
}

//查询用车申请数据分页
export function biz_car_apply(data) {
	return axios({
		url: api.gateway_act + 'biz_car_apply/listAllPage',
		method: 'get',
		params: data
	})
}

// 用车申请新增
export function biz_car_apply_save(parameter) {
	return axios({
		url:api.gateway_act + 'biz_car_apply/save',
		method: 'POST',
		data: parameter
	})
}

//获取用车申请编号
export function biz_car_apply_code(data) {
	return axios({
		url: api.gateway_act + 'biz_car_apply/code',
		method: 'get',
		params: data
	})
}

//查询还车补贴申请数据分页
export function biz_car_subsidy_apply(data) {
	return axios({
		url: api.gateway_act + 'biz_car_subsidy_apply/listAllPage',
		method: 'get',
		params: data
	})
}

//查询邮件记录
export function mail_record(data) {
	return axios({
		url: '/daily/mail_record/list',
		method: 'get',
		params: data
	})
}

// 还车补贴申请新增
export function biz_car_subsidy_apply_save(parameter) {
	return axios({
		url:api.gateway_act + 'biz_car_subsidy_apply/save',
		method: 'POST',
		data: parameter
	})
}

//获取还车补贴申请编号
export function biz_car_subsidy_apply_code(data) {
	return axios({
		url: api.gateway_act + 'biz_car_subsidy_apply/code',
		method: 'get',
		params: data
	})
}